/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PdsSyncReviewAccess_ConnectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncReviewAccess_ConnectionQuery = { organisationIntegration: { __typename: 'MissingCapabilities', missingCapabilities: Array<Types.Capabilities> } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationIntegrationResult', organisationIntegration?: { __typename: 'OrganisationIntegration', id: string } | null } };

export type PdsSyncReviewAccess_CountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncReviewAccess_CountsQuery = { pdsSyncTaskCounts: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PdsSyncTaskCounts', pending: number, autoApproved: number, approved: number, rejected: number, executed: number, failed: number } };

export type PdsSyncReviewAccess_LastSyncQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PdsSyncReviewAccess_LastSyncQuery = { pdsSyncTasks: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PdsSyncTaskConnection', items: Array<{ __typename: 'PdsSyncTask', id: string, createdAt: string }> } };


export const PdsSyncReviewAccess_ConnectionDocument = gql`
    query PdsSyncReviewAccess_Connection {
  organisationIntegration(integrationId: pds_sync) {
    ... on OrganisationIntegrationResult {
      organisationIntegration {
        id
      }
    }
    ... on MissingCapabilities {
      missingCapabilities
    }
  }
}
    `;

/**
 * __usePdsSyncReviewAccess_ConnectionQuery__
 *
 * To run a query within a React component, call `usePdsSyncReviewAccess_ConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncReviewAccess_ConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdsSyncReviewAccess_ConnectionQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncReviewAccess_ConnectionQuery(baseOptions?: Apollo.QueryHookOptions<PdsSyncReviewAccess_ConnectionQuery, PdsSyncReviewAccess_ConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdsSyncReviewAccess_ConnectionQuery, PdsSyncReviewAccess_ConnectionQueryVariables>(PdsSyncReviewAccess_ConnectionDocument, options);
      }
export function usePdsSyncReviewAccess_ConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdsSyncReviewAccess_ConnectionQuery, PdsSyncReviewAccess_ConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdsSyncReviewAccess_ConnectionQuery, PdsSyncReviewAccess_ConnectionQueryVariables>(PdsSyncReviewAccess_ConnectionDocument, options);
        }
export function usePdsSyncReviewAccess_ConnectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdsSyncReviewAccess_ConnectionQuery, PdsSyncReviewAccess_ConnectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdsSyncReviewAccess_ConnectionQuery, PdsSyncReviewAccess_ConnectionQueryVariables>(PdsSyncReviewAccess_ConnectionDocument, options);
        }
export type PdsSyncReviewAccess_ConnectionQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_ConnectionQuery>;
export type PdsSyncReviewAccess_ConnectionLazyQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_ConnectionLazyQuery>;
export type PdsSyncReviewAccess_ConnectionSuspenseQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_ConnectionSuspenseQuery>;
export type PdsSyncReviewAccess_ConnectionQueryResult = Apollo.QueryResult<PdsSyncReviewAccess_ConnectionQuery, PdsSyncReviewAccess_ConnectionQueryVariables>;
export const PdsSyncReviewAccess_CountsDocument = gql`
    query PdsSyncReviewAccess_Counts {
  pdsSyncTaskCounts {
    ... on PdsSyncTaskCounts {
      pending
      autoApproved
      approved
      rejected
      executed
      failed
    }
  }
}
    `;

/**
 * __usePdsSyncReviewAccess_CountsQuery__
 *
 * To run a query within a React component, call `usePdsSyncReviewAccess_CountsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncReviewAccess_CountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdsSyncReviewAccess_CountsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncReviewAccess_CountsQuery(baseOptions?: Apollo.QueryHookOptions<PdsSyncReviewAccess_CountsQuery, PdsSyncReviewAccess_CountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdsSyncReviewAccess_CountsQuery, PdsSyncReviewAccess_CountsQueryVariables>(PdsSyncReviewAccess_CountsDocument, options);
      }
export function usePdsSyncReviewAccess_CountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdsSyncReviewAccess_CountsQuery, PdsSyncReviewAccess_CountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdsSyncReviewAccess_CountsQuery, PdsSyncReviewAccess_CountsQueryVariables>(PdsSyncReviewAccess_CountsDocument, options);
        }
export function usePdsSyncReviewAccess_CountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdsSyncReviewAccess_CountsQuery, PdsSyncReviewAccess_CountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdsSyncReviewAccess_CountsQuery, PdsSyncReviewAccess_CountsQueryVariables>(PdsSyncReviewAccess_CountsDocument, options);
        }
export type PdsSyncReviewAccess_CountsQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_CountsQuery>;
export type PdsSyncReviewAccess_CountsLazyQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_CountsLazyQuery>;
export type PdsSyncReviewAccess_CountsSuspenseQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_CountsSuspenseQuery>;
export type PdsSyncReviewAccess_CountsQueryResult = Apollo.QueryResult<PdsSyncReviewAccess_CountsQuery, PdsSyncReviewAccess_CountsQueryVariables>;
export const PdsSyncReviewAccess_LastSyncDocument = gql`
    query PdsSyncReviewAccess_LastSync {
  pdsSyncTasks(limit: 1, offset: 0) {
    ... on PdsSyncTaskConnection {
      items {
        id
        createdAt
      }
    }
  }
}
    `;

/**
 * __usePdsSyncReviewAccess_LastSyncQuery__
 *
 * To run a query within a React component, call `usePdsSyncReviewAccess_LastSyncQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdsSyncReviewAccess_LastSyncQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdsSyncReviewAccess_LastSyncQuery({
 *   variables: {
 *   },
 * });
 */
export function usePdsSyncReviewAccess_LastSyncQuery(baseOptions?: Apollo.QueryHookOptions<PdsSyncReviewAccess_LastSyncQuery, PdsSyncReviewAccess_LastSyncQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdsSyncReviewAccess_LastSyncQuery, PdsSyncReviewAccess_LastSyncQueryVariables>(PdsSyncReviewAccess_LastSyncDocument, options);
      }
export function usePdsSyncReviewAccess_LastSyncLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdsSyncReviewAccess_LastSyncQuery, PdsSyncReviewAccess_LastSyncQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdsSyncReviewAccess_LastSyncQuery, PdsSyncReviewAccess_LastSyncQueryVariables>(PdsSyncReviewAccess_LastSyncDocument, options);
        }
export function usePdsSyncReviewAccess_LastSyncSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdsSyncReviewAccess_LastSyncQuery, PdsSyncReviewAccess_LastSyncQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdsSyncReviewAccess_LastSyncQuery, PdsSyncReviewAccess_LastSyncQueryVariables>(PdsSyncReviewAccess_LastSyncDocument, options);
        }
export type PdsSyncReviewAccess_LastSyncQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_LastSyncQuery>;
export type PdsSyncReviewAccess_LastSyncLazyQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_LastSyncLazyQuery>;
export type PdsSyncReviewAccess_LastSyncSuspenseQueryHookResult = ReturnType<typeof usePdsSyncReviewAccess_LastSyncSuspenseQuery>;
export type PdsSyncReviewAccess_LastSyncQueryResult = Apollo.QueryResult<PdsSyncReviewAccess_LastSyncQuery, PdsSyncReviewAccess_LastSyncQueryVariables>;